export default "__VITE_ASSET__D2pGLACA__"